module.exports = __webpack_public_path__ + "img/SKMJ_rest2.abf9ea8c.jpg";